import { getdirectusUserFields } from "components/user/config";
import { readComments, createComments } from "directus/src/operations";

export async function fetchBillableActivities(billableId) {
  try {
    const query = {
      fields: [
        "id",
        "collection",
        "item",
        getdirectusUserFields("user_created"),
        "date_created",
        "comment",
        "attachment.id",
        "attachment.type",
      ],
      filter: {
        collection: { _eq: "billables" },
        item: { _eq: billableId },
      },
      sort: ["-date_created"],
      limit: -1,
    };

    const data = await readComments(query);
    return data || [];
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function createBillableActivity({ item }) {
  try {
    const query = {
      fields: [
        "id",
        "collection",
        "item",
        getdirectusUserFields("user_created"),
        "comment",
        "date_created",
        "attachment.id",
        "attachment.type",
        "attachment.url",
        "attachment.name",
      ],
    };

    const data = await createComments(item, query);
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export async function fetchBillableActivityCount(billableId) {
  try {
    const data = await readComments({
      fields: ["id"],
      filter: { collection: { _eq: "billables" }, item: { _eq: billableId } },
      limit: -1,
    });
    return (data || []).length;
  } catch (error) {
    console.error(error);
    return 0;
  }
}
